import { Component } from '@angular/core';

@Component({
  selector: 'studio-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
})
export class FormErrorComponent {}
